function addMeta(meta_keywords, meta_description) {
    if (meta_keywords) {
        $('meta[name=keywords]').attr('content', meta_keywords);
    }
    if (meta_description) {
        $('meta[name=description]').attr('content', meta_description);
    }
}

$(document).ready(function() {
    $('body').on('keypress', '.integer', function (event) {
        if ((event.which != 46 || $(this).val().indexOf('.')  < 0) && (event.which < 48 || event.which > 57)) {
            event.preventDefault();
        }
    });
});